module.exports = __webpack_public_path__ + "static/media/local-area-photo-product.4788e75c.jpg";